import type { Lfa_Account_Settings__Input } from '~/graphql/types';
import removeTypenames from '~/util/removeTypenames';
import type { UpdateSettingsState } from '../../reducers/settingsReducer';

/**
 * Returns updated lfa account settings input
 * @param {UpdateSettingsState} updateSettings - The update settings state
 * keywords: lfaAccountSettings
 */
const getUpdatedSettingsInput = (
  updateSettings: UpdateSettingsState,
): Lfa_Account_Settings__Input => {
  const {
    description,
    flynck,
    callbackPhoneNumber,
    services: updatedServices,
    ...rest
  } = updateSettings;

  const flynckSettings: Lfa_Account_Settings__Input['flynck'] = flynck
    ? {
        importSetupID: flynck.importSetupID,
        contextID: flynck.contextID,
      }
    : null;

  const updatedFields: Lfa_Account_Settings__Input = removeTypenames({
    ...rest,
    services: updatedServices.map(service => ({
      id: service.id,
      locations: service.locations
        .map(location =>
          location.enabled
            ? {
                type: location.type,
                note: location.note,
                weight: location.weight,
              }
            : null,
        )
        .filter(Boolean),
    })),
    rules: {
      ...rest.rules,
      minLeadscore: Number(rest.rules.minLeadscore),
    },
    ...(description && { description }),
    ...(flynckSettings && { flynck: flynckSettings }),
    ...(callbackPhoneNumber && { callbackPhoneNumber }),
  });

  return updatedFields;
};
export default getUpdatedSettingsInput;
